import React from 'react';
import EmailComposeContainer from '../../Componant/Email/Compose';

const EmailCompose = () => {
  return (
    <div className='page-body'>
      <EmailComposeContainer />
    </div>
  );
};

export default EmailCompose;
